import * as React from 'react';
import {useFormikContext} from 'formik';
import Row from 'components/Row';
import Column from 'components/Column';
import FormContainer from '../../containers/FormContainer';
import {WebinarObject} from 'api/webinar/types';
import Input from 'components/Input';

/**
 * The record time form part
 * @return {React.ReactElement}
 * @constructor
 */
export default function RecordTimeForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<WebinarObject>>();

  /**
   * Render content
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Handle date change
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
      formContext.setFieldValue('recordTime.days', event.target.value);
      formContext.submitForm();
    }

    return (
      <React.Fragment>
        <Row>
          <Column>
            <Row>
              <Column>
                <Input
                  label="Введите кол-во дней:"
                  note="Оставьте поле пустым, если без ограничений"
                  placeholder="Без ограничений"
                  onChange={handleChange}
                  required
                />
              </Column>
            </Row>
          </Column>
        </Row>
      </React.Fragment>
    );
  }

  return (
    <FormContainer
      property="recordTime"
      label="Запись трансляции доступна после ее завершения"
      collapse>
      {renderContent()}
    </FormContainer>
  );
}
